import React from 'react';

import { useAnalyticsEvent } from '@/providers/AnalyticsProvider';
import { Button } from '@material-ui/core';
import { useSnackbar } from 'notistack';
import { useCopyToClipboard } from 'react-use';

import { ChatContainerMessage } from '../../ChatContainer';
import styles from './FocusedOptionsBar.module.scss';

export interface FocusedOptionsBarProps {
	focusedMessage?: ChatContainerMessage;
	className?: string;
	active?: boolean;
}

export const FocusedOptionsBar = ({
	focusedMessage,
	className,
	active,
}: FocusedOptionsBarProps) => {
	const [_value, copy] = useCopyToClipboard();
	const { enqueueSnackbar } = useSnackbar();
	const fireCopyMessageEvent = useAnalyticsEvent('Chat_Copy_Message');

	const classes = [
		styles['focused-options-bar'],
		active && styles['active'],
		className,
	]
		.filter(Boolean)
		.join(' ');

	return (
		<div className={classes}>
			<Button
				onClick={() => {
					if (focusedMessage) {
						copy(focusedMessage.content);
						enqueueSnackbar('Message copied');
						fireCopyMessageEvent();
					}
				}}
			>
				Copy
			</Button>
		</div>
	);
};
